import * as backend from '@/lib/backend';
import { trackError } from '@/lib/error_tracker';

import SupportEmailLink from '@/components/SupportEmailLink';
import SupportTwitterLink from '@/components/SupportTwitterLink';

export default async function createCheckoutSession(
  dispatch,
  session,
  pathname,
  planId
) {
  const { exception, error, response, data } =
    await backend.createCheckoutSession(session, {
      planId,
      queryParams: {
        successUrl: `${window.location.origin}/${session.getIn([
          'user',
          'username',
        ])}?success=true`,
        cancelUrl: `${window.location.href}?cancel=true`,
      },
    });

  if (error || exception) {
    dispatch({
      type: 'setFlashMessage',
      data: {
        type: 'error',
        message: (
          <span>
            There was an issue subscribing, please try again. If it still
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            doesn't work please reach out at{' '}
            <SupportEmailLink sessionOrSessionData={session} /> or{' '}
            <SupportTwitterLink sessionOrSessionData={session} />.
          </span>
        ),
      },
    });

    // TODO(@alerting): this one should alert on Slack or something!
    trackError(session, 'Plan Subscription Failed', exception, {
      pathname,
      ...(response
        ? {
            responseStatus: response && response.status,
          }
        : {}),
    });

    return;
  }

  window.location.assign(data.sessionUrl);
}
